import { LogOutIcon } from 'lucide-react';

import { Avatar, AvatarFallback } from '@mds/shared/ui/shadcn/avatar';
import { Button } from '@mds/shared/ui/shadcn/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@mds/shared/ui/shadcn/dropdown-menu';

import { useSession } from '@/auth/use-session';
import { initials } from '@/lib/initials';

/** The avatar dropdown in the header: who is signed in, and the way out. */
export default function UserMenu() {
  const { session, signOut } = useSession();
  const user = session?.user;

  const name = [user?.firstName, user?.lastName].filter(Boolean).join(' ');
  const role = session?.roles[0]?.name;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="rounded-full">
          <Avatar>
            <AvatarFallback className="text-xs font-medium">
              {user ? initials(user.firstName, user.lastName, user.email) : '··'}
            </AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel className="flex flex-col gap-0.5">
          <span>{name || user?.email || 'Signed in'}</span>
          {user && (
            <span className="text-xs font-normal text-muted-foreground">
              {name ? user.email : (role ?? '')}
            </span>
          )}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem variant="destructive" onSelect={() => void signOut()}>
          <LogOutIcon />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
